import { CustomerDto } from 'src/store/customers/customer';
import { ArrayUtils } from 'src/utils/array';
import { CustomerAction, CustomerTypes } from './customers.actions';

export type CustomersState = Readonly<{
  customers: CustomerDto[];
  errors: any;
}>;

const initialState: CustomersState = {
  customers: [],
  errors: null
};

const customersReducer = (
  state: CustomersState = initialState,
  action: CustomerAction
) => {
  switch (action.type) {
    case CustomerTypes.FetchAll:
      return { ...state, customers: action.customers };
    case CustomerTypes.Add:
      return {
        ...state,
        customers: [...state.customers, action.customer]
      };
    case CustomerTypes.Update:
      return {
        ...state,
        customers: ArrayUtils.updateListById(state.customers, action.customer)
      };
    case CustomerTypes.Delete:
      return {
        ...state,
        customer: null,
        customers: ArrayUtils.deleteFromListById(
          state.customers,
          action.customer
        )
      };
    case CustomerTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default customersReducer;
